<template lang="pug">
  section.form-section(v-if="false")
    .registration(v-if="!isSent")
      .anchor#form-anchor
      .container
        h2.registration__title Регистрация
        .registration__wrapper
          form#page-form.form(
            @submit.prevent="ajax()"
            method="post"
          )
            .form__inner
              .form__wrapper
                label.form__input-label
                  .form__input-description(data-error=" — Oбязательное поле") Имя
                  input.form__input(
                    required="required"
                    name="name"
                    v-model.trim="participant.name"
                    v-bind:class="{}"
                    type="text"
                    placeholder="Иван"
                    @blur="checkEmpty(participant.name)"
                  )
                label.form__input-label
                  .form__input-description(data-error=" — Oбязательное поле") Фамилия
                  input.form__input(
                    required="required"
                    name="surname"
                    v-model.trim="participant.surname"
                    v-bind:class="{}"
                    type="text"
                    placeholder="Иванов"
                    @blur="checkEmpty(participant.surname)"
                  )
                label.form__input-label
                  .form__input-description(data-error=" — Oбязательное поле") Телефон
                  input.form__input(
                    required="required"
                    name="phone"
                    v-model.trim="participant.phone"
                    v-bind:class="{}"
                    type="tel"
                    placeholder="+7 495 921 36 44"
                    @blur="checkEmpty(participant.phone)"
                  )
                label.form__input-label
                  .form__input-description(data-error=" — Oбязательное поле") Рабочая почта
                  input.form__input(
                    required="required"
                    name="email"
                    v-model.trim="participant.email"
                    v-bind:class="{}"
                    type="email"
                    placeholder="example@mindbox.ru"
                    @input="validateForm"
                    @blur="checkValueByRegEx(participant.email, regEmail)"
                  )

                label.form__input-label
                  .form__input-description(data-error=" — Oбязательное поле") Компания
                  input.form__input(
                    required="required"
                    name="company"
                    v-model.trim="participant.company"
                    v-bind:class="{}"
                    type="text"
                    placeholder="Mindbox"
                    @input="validateForm"
                    @blur="checkEmpty(participant.company)"
                  )
                label.form__input-label
                  .form__input-description(data-error=" — Oбязательное поле") Адрес сайта
                  input.form__input(
                    required="required"
                    name="site"
                    v-model.trim="participant.site"
                    v-bind:class="{}"
                    type="text"
                    placeholder="mindbox.ru"
                    @input="validateForm"
                    @blur="checkValueByRegEx(participant.site, regSite)"
                  )
                label.form__input-label
                  .form__input-description(data-error=" — Oбязательное поле") Роль в&nbsp;компании
                  input.form__input(
                    required="required"
                    name="participant.role"
                    v-model.trim="participant.role"
                    v-bind:class="{}"
                    type="text"
                    placeholder="Директор"
                    @input="validateForm"
                    @blur="checkEmpty(participant.role)"
                  )
                label.form__input-label
                  .form__input-description Вопрос к&nbsp;СЕО (необязательно)
                  input.form__input(
                    name="question"
                    v-model.trim="question"
                    v-bind:class="{}"
                    type="text"
                    placeholder="Задайте вопрос, который вас волнует"
                  )
                .form__submit-wrapper
                  .form__submit-label
                    input.form__submit(
                      type="submit"
                      value="регистрация"
                      v-bind:class="isSending ? 'form__submit--sending' : ''")
                  p.form__agreement Регистрируясь, вы&nbsp;подтверждаете согласие на&nbsp;обработку #[a(href="https://mindbox.ru/documents/policy/" target="_blank") персональных данных]
          .about
            .about__hr
              <svg width="6" height="2400" viewBox="0 0 6 2400" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 2400L3.0001 -3.0756e-05" stroke="black" stroke-width="5" stroke-dasharray="24 24"/>
              </svg>
              <svg width="1140" height="4" viewBox="0 0 1140 4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 2H1140" stroke="black" stroke-width="3" stroke-dasharray="24 24"/>
              </svg>

            .about__wrapper
              p.about__date 24 ноября <br>15:00–17:00 <br>online
              p.about__free Вход&nbsp;свободный
            p.about__event CEO Summit 2022
            p.about__text CEO соберутся в&nbsp;студии в&nbsp;центре Москвы, а&nbsp;зрители будут смотреть прямую трансляцию и&nbsp;задавать вопросы
    FormSuccess(
      v-if="isSent"
      :participant="participant"
      :question="question"
    )
</template>

<script>
import axios from "axios";
import FormSuccess from './components/FormSuccess.vue';
import {
  customGetCookie,
  convertUtmToOneLine,
  getCurrentEntrancePoint,
  getUtmData,
  getYandexClientId,
  getGoogleClientId
} from "../scripts/helpers";
export default {
  name: "PageForm",
  components: {
    FormSuccess,
  },
  data() {
    return {
      formSelector: '#page-form',
      regEmail: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,7})$/,
      regSite: /^(\s{1,3})?((https?|ftp|smtp):\/\/)?(www.)?[a-zA-Zа-яА-Яё0-9_\-\.]+(\.[a-zA-Zа-яА-Яё]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?(\s{1,3})?$/,

      participant: {
        name: '',
        surname: '',
        phone: '',
        email: '',
        site: '',
        company: '',
        role: ''
      },
      question: '',
      errors: [],
      preloaderActive: false,
      isSent: false,
      isSending: false,
      errorValidate: '',
    }
  },
  methods: {

    validateForm() {
      this.errors = [];
      for (let key in this.participant) {
        if (this.participant[key].length < 1) {
          this.errors.push(`Пустое поле в ${key}`);
        }
      }

      if (!this.regEmail.test(this.participant['email'])) {
        this.errors.push('Невалидный email');
      }

      if (!this.regSite.test(this.participant['site'])) {
        this.errors.push('Невалидный сайт');
      }

      console.log(this.errors)
    },

    checkEmpty(value) {
      const elem = event.target;
      const parentElem = elem.parentElement;

      if (value.length < 1) {
        parentElem.classList.add('error')
        // this.errorValidate = '';

        return true;

      } else if (value.length > 0 && parentElem.classList.contains('error')) {
        parentElem.classList.remove('error')
        // this.errorValidate = '';

        return false;
      }
    },

    checkValueByRegEx(value, reg) {
      const elem = event.target;
      const parentElem = elem.parentElement;

      if (!reg.test(value)) {
        parentElem.classList.add('error')
      } else if (reg.test(value) && parentElem.classList.contains('error')) {
        parentElem.classList.remove('error')
      }

      this.validateForm();
    },
    ajax() {
      if (this.errors.length > 0) {
        return false
      }

      this.isSending = true;

      this.preloaderActive = true;
      const url = 'https://mindbox.ru/journal/ajax/ajax.php';

      const data = {
        action: 'ceo_summit',
        participant: this.participant,
        uuid: customGetCookie('mindboxDeviceUUID')
            ? customGetCookie('mindboxDeviceUUID')
            : customGetCookie('deviceUUID'),
        utmData: getUtmData(),
        url: window.location.href,
        googleClientId: getGoogleClientId(),
        metrikaid: getYandexClientId(),
        firstmetrikaid: getYandexClientId(),
        currentEntrancePoint: getCurrentEntrancePoint(),
        question: this.question
      }

      axios.post(url, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.data)
      .then(data => {
        if (data.status == 'Success') {
          this.isSent = true;
          this.isSending = false;
          document.body.classList.add('success-form')
          this.outSuccessWindow();
        }
      })
      .catch(e => {
      })
    },

    outSuccessWindow() {
      window.scrollBy(0, -10000);
      const outLinks = document.querySelectorAll('.menu__item-btn, .mobile-menu__item-link, .mobile-menu__item-btn, .menu__item-link, .logos__mindbox')

      outLinks.forEach(item => {
        item.addEventListener('click', () => {
          document.body.classList.remove('success-form');
          this.isSent = false;
          this.isSending = false;
        })
      });
    }
  },
}
</script>

<style scoped lang="scss">

</style>